// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export enum FoundationDateRangeFilter {
  'ALL TIME' = 'all',
  'CURRENT YEAR' = 'this_year',
  'LAST YEAR' = 'last_year',
}
